// Copyright 2019 Sorama B.V.

import { containerless } from "aurelia-framework";
import { AspectItemsCatalog } from "./AspectItemsCatalog";
import { AspectItemRatio, IAspectItem } from "./IAspectItem";

@containerless
export class AspectFixed implements IAspectItem {
    private element: HTMLDivElement;

    constructor(private readonly aspectItemsCatalog: AspectItemsCatalog) {}

    public attached(): void {
        this.aspectItemsCatalog.subscribe({
            viewModel: this,
            element: this.element,
        });
    }

    public getArea(maxWidth: number, maxHeight: number): AspectItemRatio {
        const width = Math.min(maxWidth, this.element.clientWidth);
        const height = Math.min(maxHeight, this.element.clientHeight);

        return <AspectItemRatio>{
            height: height,
            width: width,
            ratio: width / height,
        };
    }
}
